<template>
  <div>
    <simpletoolbar />
    <main class="max-w-3xl mx-auto px-4 py-10">
      <h1 class="text-3xl font-bold text-stone-800 dark:text-stone-100 mb-2">
        Blog
      </h1>
      <p class="text-stone-500 dark:text-stone-400 mb-10">
        Tips, guides, and ideas for teachers, event organizers, streamers, and anyone who loves a good spin.
      </p>

      <template v-for="(posts, year) in postsByYear" :key="year">
        <h2 class="text-xl font-semibold text-stone-600 dark:text-stone-300 mb-4 mt-8 border-b border-stone-200 dark:border-stone-700 pb-2">
          {{ year }}
        </h2>
        <ul class="space-y-6">
          <li v-for="post in posts" :key="post.path">
            <router-link
              :to="post.path"
              class="group block rounded-lg p-4 hover:bg-stone-50 dark:hover:bg-stone-800 transition-colors"
            >
              <h3 class="text-lg font-semibold text-primary-600 dark:text-primary-400 group-hover:underline">
                {{ post.title }}
              </h3>
              <p class="text-sm text-stone-500 dark:text-stone-400 mt-1">
                {{ formatDate(post.date) }}
              </p>
              <p class="text-stone-600 dark:text-stone-300 mt-2 text-sm leading-relaxed">
                {{ post.description }}
              </p>
            </router-link>
          </li>
        </ul>
      </template>
    </main>
    <app-footer />
  </div>
</template>

<script setup>
import simpletoolbar from '@components/ui/simpletoolbar.vue';
import appFooter from '@components/ui/appFooter.vue';
import { useSeo } from '@/composables/useSeo';
import { getPostsByYear } from '@utils/BlogLoader.js';

const postsByYear = getPostsByYear();

useSeo({
  title: 'Blog | Spin the Names',
  description:
    'Tips, guides, and ideas for using Spin the Names in your classroom, events, live streams, and more.',
});

function formatDate(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  return d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
}
</script>
